import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { token: String }

  static targets = ["hiddenToken", "revealedToken"]

  toggleKeyVisibility() {
    $(this.hiddenTokenTarget).toggle()
    $(this.revealedTokenTarget).toggle()
  }
}
